<div class="modal-body d-flex flex-column  align-items-center justify-content-center pt-4 pb-4">
  <img class="mb-3" src="assets/params/images/icons/ic-no-translate.svg" width="100" height="100">
  <h5><strong>This page couldn't be translated</strong></h5>
  <h6>Would you like to continue and view the content in Vietnamese?</h6>
  <button class="btn-login nav-link mb-3 mt-2" (click)="goToNextPage()">
    View content in Vietnamese
  </button>
  <span class="custom-link" (click)="dismiss()">Close</span>
</div>